import PlayerPlayFilled from './src/player-play-filled';
export default PlayerPlayFilled;